import { MessageBox } from '@gower/react-ui/message-box';
import { expose, MutableStore, ViewStatus } from '@gower/react-ui/store';
import { User } from '@gower/shared-sdk/core/users';
import CredentialProvider from 'app/credential-provider';

export class ProfileStoreSubstore extends MutableStore {

    private _store: ProfileStore;
    protected get MainStore () { return this._store; }
    protected get Item () { return this.MainStore?.Item; }

    ___internal___mounted ( props ) {
        this._store = props.store;
    }
}

class ProfileStore extends MutableStore {

    public readonly Status = ViewStatus.new( 'loading' );
    public Item: User = null;

    async onReceiveProps () {

        const userId = CredentialProvider.getUserId();

        if ( !this.Item || userId !== this.Item?.Id ) {

            this.Status.setLoading();

            if ( userId ) {
                const user = await User.findById( userId );
                if ( user ) {
                    this.Item = user;
                    this.Status.setOk();
                }
            }

            if ( !this.Item ) {
                this.Status.setEmpty();
                MessageBox.Accept( 'Usuario no existe' );
            }
        }
    }
}

export const { useStore, provider } = expose( ProfileStore );